var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"sub-component-header"},[_vm._v("\n  "+_vm._s(_vm.title)+" "),(_vm.isBeta)?_c('span',{staticClass:"beta-badge"},[_vm._v("BETA")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }